import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import IndexPage from './pages/Index';
import NotFoundPage from './pages/NotFound';
import AccountLockPage from './pages/AccountLock';

const App: React.FC = () => {
    return (
        <Router>
            <Switch>
                <Route path="/" exact>
                    <IndexPage />
                </Route>
                <Route path="/secure" exact>
                    <AccountLockPage />
                </Route>
                <Route path="/not-found">
                    <NotFoundPage />
                </Route>
                <Route default>
                    <Redirect to="/not-found" />
                </Route>
            </Switch>
        </Router>
    );
};

export default App;
